import Http from '@/api/http.js'

export default {
  index() {
    return Http.get('/system_flags')
  },

  update(id, system_flag) {
    return Http.put(`/system_flags/${id}`, { system_flag })
  },
}
